import { AuthGuard } from '@account/guards/auth-guard.service';
import { BAVEL_PATH } from './auxiliary/config/app-config';
import { BrowserCompatibilityGuard } from '@shared/guards/compatibility-guard.service';
import { BrowserNotSupportedComponent } from '@shared/components/error-pages/browser-not-supported/browser-not-supported.component';
import { HasRoleGuard } from '@shared/guards/has-role.guard';
import { NgModule } from '@angular/core';
import { ROLES } from '@account/services/auth.service';
import { Routes, RouterModule } from '@angular/router';
import { ToolMainComponent } from '@tool/components/main/tool-main.component';
import { UserProfileResolverService } from '@shared/services/user-profile-resolver.service';
import { AuthenticationFailComponent } from '@shared/components/error-pages/authentication-fail/authentication-fail.component';

const routes: Routes = [
  {
    path: '',
    component: ToolMainComponent,
    canActivate: [AuthGuard, BrowserCompatibilityGuard],
    resolve: { userProfile: UserProfileResolverService },
    children: [
      {
        path: BAVEL_PATH.BAVELPAY_TRAVEL,
        loadChildren: () => import('./bavel-pay-travel/bavel-pay-travel.module').then(m => m.BavelPayTravelModule),
        canActivate: [HasRoleGuard],
        data: { role: ROLES.EPAYMENTS_CLIENT_TRAVEL },
      },
      {
        path: BAVEL_PATH.BAVEL_COLLECT_TRAVEL,
        loadChildren: () => import('./bavel-collect-travel/bavel-collect-travel.module').then(m => m.BavelCollectTravelModule),
        canActivate: [HasRoleGuard],
        data: { role: ROLES.FN_EPAYMENTS_SUPPLIER }
      },
      { path: BAVEL_PATH.BAVEL_COLLECT_TRAVEL_OLD, redirectTo: BAVEL_PATH.BAVEL_COLLECT_TRAVEL }
    ]
  },
  { path: BAVEL_PATH.BROWSERNOTSUPPORTED, component: BrowserNotSupportedComponent },
  { path: BAVEL_PATH.AUTHENTICATIONFAILED, component: AuthenticationFailComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
